import {PostListQueryModel} from '@/types/channel/board/board.model';

export const POST_LIST_PREFIX = 'postList';

/**
 * 게시글 목록 쿼리 키 생성 함수
 * - 아래 validate 정의된 내용 없으면 API 이동 안함 >> 참고
 * @param userId - 사용자 ID
 * @param params - 게시글 목록 조회 파라미터 (선택사항)
 * @returns 쿼리 키 배열
 */
const createPostListQueryKey = (
  userId: string,
  params?: Partial<PostListQueryModel>,
) => {
  const baseKey = [POST_LIST_PREFIX, userId];

  if (!params) {
    return baseKey;
  }

  // 실제로 존재하는 값들만 필터링하여 쿼리 키에 추가
  const validParams: Record<string, any> = {};

  if (params.search !== undefined && params.search !== '') {
    validParams.search = params.search;
  }

  if (params.sort !== undefined) {
    validParams.sort = params.sort;
  }

  if (params.type !== undefined) {
    validParams.type = params.type;
  }

  if (params.period !== undefined) {
    validParams.period = params.period;
  }

  if (params.startDate !== undefined && params.startDate !== '') {
    validParams.startDate = params.startDate;
  }

  if (params.endDate !== undefined && params.endDate !== '') {
    validParams.endDate = params.endDate;
  }

  if (params.boardNumber !== undefined && params.boardNumber !== '') {
    validParams.boardNumber = params.boardNumber;
  }

  if (params.page !== undefined) {
    validParams.page = params.page;
  }

  // 유효한 파라미터가 있는 경우에만 추가
  return Object.keys(validParams).length > 0
    ? [...baseKey, validParams]
    : baseKey;
};

export const FIX_TO_HOME_PREFIX = 'fixToHome';

export const REPORT_PREFIX = 'report';

export const FAVORITE_PREFIX = 'favorite';

export const BOARD_QUERY_KEY = {
  POST_LIST: (userId: string, params?: Partial<PostListQueryModel>) =>
    createPostListQueryKey(userId, params),
  FIX_TO_HOME: (userId: string, titleNo: number) =>
    [FIX_TO_HOME_PREFIX, userId, titleNo] as const,
  REPORT: (userId: string, isStationReport: boolean) =>
    [REPORT_PREFIX, userId, isStationReport] as const,
  FAVORITE: (userId: string) => [FAVORITE_PREFIX, userId] as const,
} as const;
